<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">
      {{ $t("src.views.apps.yatirimci.liste.title") }}
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.yeniKaydet")' :open-delay="500" placement="top">
          <el-button v-on:click="routeMusteri('Yatırımcı Tanımla')" size="mini" type="text"
                     icon="el-icon-plus"></el-button>
        </el-tooltip>
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
         :element-loading-text='loading ? $t("src.views.apps.yatirimci.liste.loading") : $t("src.views.apps.yatirimci.liste.stateLoading")'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <div>
            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                            text-color="gray" :disabled="searchLoading">
              <el-radio-button label="1">
                <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="selectIcon === '1'">{{ $t("src.views.apps.yatirimci.liste.active") }}</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="0">
                <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="selectIcon === '0'">{{
                      $t("src.views.apps.yatirimci.liste.passive")
                    }}</label>
                </transition>
              </el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <br v-if="!isDesktop">
        <br v-if="!isDesktop">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <ul class="islemler">
              <li>
                <i class="mdi mdi-file-pdf-box mdi-18px" style="color: #378CE7"/>
                <span>PDF Çıktısını Al</span>
              </li>
              <li>
                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #f7ba2a"></i>
                <span>{{ $t("src.views.apps.yatirimci.liste.table.editCustomer") }}</span>
              </li>
              <li v-if="selectIcon === '1'">
                <i class="mdi mdi-trash-can mdi-18px" style="color: #ec205f"></i>
                <span>{{ $t("src.views.apps.yatirimci.liste.table.setPassive") }}</span>
              </li>
              <li v-else>
                <i class="mdi mdi-play mdi-18px" style="color: #048484"></i>
                <span>{{ $t("src.views.apps.yatirimci.liste.table.setActive") }}</span>
              </li>
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <div class="my-custom-table">
        <el-table v-loading="searchLoading" border stripe :data="musteriProjeList" @expand-change="handleExpand"
                  style="width: 100%" :element-loading-text='"Yatırımcılar Aranıyor. Lütfen Bekleyiniz."'
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
          <el-table-column>
            <el-table-column prop="adres" :label='$t("src.views.apps.yatirimci.liste.table.adres")' width="100">
              <template slot-scope="props">
                <div class="text-center">
                  <el-image @click="downloadFile(props.row.logo)"
                            :src="musteriService.logoPath + props.row.logo"
                            style="width: 50px; height: 50px;cursor: pointer"/>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="props">
              <el-input clearable v-on:clear="musteriAra"
                        placeholder='Yatırımcı Ara' v-model="firmaAdiAra"
                        v-debounce:500ms="musteriAra" size="mini"></el-input>
            </template>
            <el-table-column prop="musteriAdi" label="Yatırımcı Adı" min-width="250">
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="props">
              <el-input clearable v-on:clear="musteriAra"
                        :placeholder='$t("src.views.apps.yatirimci.liste.search.searchUnvan")' v-model="unvanAra"
                        v-debounce:500ms="musteriAra" size="mini"></el-input>
            </template>
            <el-table-column prop="unvan" :label='$t("src.views.apps.yatirimci.liste.table.unvan")' min-width="250">
              <template slot-scope="props">
                <div class="new-line-text">
                  {{ props.row.unvan }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="adres" :label='$t("src.views.apps.yatirimci.liste.table.adres")' min-width="200">
              <template slot-scope="props">
                <div class="new-line-text">
                  {{ props.row.adres }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="telefon" :label='$t("src.views.apps.yatirimci.liste.table.telephone")'
                             min-width="150">
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="eposta" :label='$t("src.views.apps.yatirimci.liste.table.email")' min-width="200">
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <el-table-column :label='$t("src.views.apps.genel.islem")' align="right" width="150">
              <template slot-scope="scope">
                <el-tooltip content='Pdf Çıktısını Al' :open-delay="500" placement="bottom">
                  <el-button @click="pdfModalOpen(scope.row)" class="pdf-button" type="text"><i
                      class="mdi mdi-file-pdf-box"/>
                  </el-button>
                </el-tooltip>
                <el-tooltip :content='$t("src.views.apps.yatirimci.liste.table.editCustomer")'
                            :open-delay="500" placement="bottom">
                  <el-button @click="updatePage(scope.row)" type="text" class="islem-button"
                             style="color: #f7ba2a; margin-left: 0px !important;"
                             icon="mdi mdi-circle-edit-outline mdi-24px">
                  </el-button>
                </el-tooltip>
                <el-tooltip :content='$t("src.views.apps.yatirimci.liste.table.setPassive")' :open-delay="500"
                            v-if="selectIcon === '1'" placement="bottom">
                  <el-button @click="changeMusteriDurum(scope.row, '0')" class="buttonDel"
                             style="margin-left: 15px !important;" type="text"
                             icon="mdi mdi-trash-can mdi-24px"></el-button>
                </el-tooltip>
                <el-tooltip :content='$t("src.views.apps.yatirimci.liste.table.setActive")' :open-delay="500"
                            v-if="selectIcon === '0'" placement="bottom">
                  <el-button @click="changeMusteriDurum(scope.row, '1')" type="text"
                             style="margin-left: 15px !important;" class="islem-button-play islem-button ml-15"
                             icon="mdi mdi-play mdi-24px"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                     @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                     :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page" @next-click="pageChange"
                     @prev-click="pageChange">
      </el-pagination>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="60%">
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="pdfData.musteriAdi"
          :pdf-quality="5"
          :manual-pagination="true"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2Pdf"
      >
        <section slot="pdf-content">
          <el-row class="pdf-modal">
            <el-col :span="24" class="text-center">
              <el-image @click="downloadFile(pdfData.logo)"
                        :src="musteriService.logoPath + pdfData.logo"
                        style="width: 150px; height: 150px;cursor: pointer"/>
            </el-col>
            <el-col :span="24" class="text-center">
              <el-divider content-position="center">Yatırımcı Bilgileri</el-divider>
            </el-col>
            <el-col :xl="12" :lg="12" :md="24" :sm="24">
              <ul>
                <li>
                  <span>Yatırımcı Adı:</span>
                  <p>{{ pdfData.musteriAdi }}</p>
                </li>
                <li>
                  <span>Ünvan:</span>
                  <p>{{ pdfData.unvan }}</p>
                </li>
                <li>
                  <span>Telefon:</span>
                  <p>{{ pdfData.telefon }}</p>
                </li>
                <li>
                  <span>E-Posta:</span>
                  <p>{{ pdfData.eposta }}</p>
                </li>
              </ul>
            </el-col>
            <el-col :xl="12" :lg="12" :md="24" :sm="24">
              <ul>
                <li>
                  <span>Vergi No:</span>
                  <p>{{ pdfData.vergiNo }}</p>
                </li>
                <li>
                  <span>Vergi Dairesi:</span>
                  <p>{{ pdfData.vergiDairesi }}</p>
                </li>
                <li>
                  <span>Adres:</span>
                  <p>{{ pdfData.adres }}</p>
                </li>
                <li>
                  <span>Web Site:</span>
                  <p>{{ pdfData.website }}</p>
                </li>
              </ul>
            </el-col>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <ul>
                <li>
                  <span>Not:</span>
                  <p>{{ pdfData.not }}</p>
                </li>
              </ul>
            </el-col>
          </el-row>
        </section>
      </vue-html2pdf>
      <el-row class="pdf-modal">
        <el-col :span="24" class="text-center">
          <el-image @click="downloadFile(pdfData.logo)"
                    :src="musteriService.logoPath + pdfData.logo"
                    style="width: 150px; height: 150px;cursor: pointer"/>
        </el-col>
        <el-col :span="24" class="text-center">
          <el-divider content-position="center">Yatırımcı Bilgileri</el-divider>
        </el-col>
        <el-col :xl="12" :lg="12" :md="24" :sm="24">
          <ul>
            <li>
              <span>Yatırımcı Adı:</span>
              <p>{{ pdfData.musteriAdi }}</p>
            </li>
            <li>
              <span>Ünvan:</span>
              <p>{{ pdfData.unvan }}</p>
            </li>
            <li>
              <span>Telefon:</span>
              <p>{{ pdfData.telefon }}</p>
            </li>
            <li>
              <span>E-Posta:</span>
              <p>{{ pdfData.eposta }}</p>
            </li>
          </ul>
        </el-col>
        <el-col :xl="12" :lg="12" :md="24" :sm="24">
          <ul>
            <li>
              <span>Vergi No:</span>
              <p>{{ pdfData.vergiNo }}</p>
            </li>
            <li>
              <span>Vergi Dairesi:</span>
              <p>{{ pdfData.vergiDairesi }}</p>
            </li>
            <li>
              <span>Adres:</span>
              <p>{{ pdfData.adres }}</p>
            </li>
            <li>
              <span>Web Site:</span>
              <p>{{ pdfData.website }}</p>
            </li>
          </ul>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24">
          <ul>
            <li>
              <span>Not:</span>
              <p>{{ pdfData.not }}</p>
            </li>
          </ul>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">Kapat</el-button>
        <el-button size="mini" type="primary" @click="generateReport()">PDF'e Dönüştür</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import musteriService from '../../../WSProvider/MusteriService'
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import VueHtml2pdf from 'vue-html2pdf'

var moment = require('moment');

export default {
  name: "MusteriListesi",
  computed: {
    musteriService() {
      return musteriService
    }
  },
  components: {VueHtml2pdf},
  data() {
    return {
      pdfData: [],
      dialogVisible: false,
      isDesktop: false,
      loading: false,
      stateLoading: false,
      searchLoading: false,
      //editDialogLoading: false,
      editDialog: false,
      editDialogData: {},
      musteriList: [],
      musteriProjeList: [],
      yetkiListesi: [],
      tarihler: [],
      yetkiTuru: "",
      yoneticiID: "",
      radio: '1',
      musteriForm: {
        musteriAdi: "",
        eposta: "",
        firmaAdi: "",
        unvan: "",
        telefon: ""
      },
      rulesMusteri: {},
      sizes: 20,
      selectIcon: '1',
      page: 0,
      postPage: 0,
      total: 4,
      firmaAdiAra: "",
      unvanAra: "",
      adresAra: "",
      telefonAra: "",
      epostaAra: "",
    }
  },
  created() {
    this.checkDevice();
    if (localStorage.getItem("userDataDemirag")) {
      this.yetkiTuru = this.$store.getters.getYetkiTuru;
      this.yetkiListesi = this.$store.getters.getYetkiListesi;
      this.yoneticiID = this.$store.getters.getYoneticiID;
      //console.log(this.yetkiListesi)
    }
    EventBus.$on("musterilistesi", (durum) => {
      this.refreshPage(durum)
    });
  },
  mounted() {
    //this.getMusteriListesi();
    this.getMusteriProjeListesi();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    pdfModalOpen(data) {
      this.pdfData = data
      this.dialogVisible = true
    },
    downloadFile(logo) {
      var downloadLink = document.createElement("a");
      downloadLink.href = musteriService.logoPath + logo;
      downloadLink.download = logo;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    async handleExpand({musteriID}, row) {
      try {

        if (row.length > 0) {
          let detail = await musteriService.musteriBilgiListesi(musteriID)
          let index = this.musteriProjeList.findIndex(x => x.musteriID === musteriID)
          this.musteriProjeList[index]["ekBilgi"] = detail.data
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 768;
    },
    updatePage(data) {
      this.$store.commit('changeMusteriUpdateData', data.musteriID)
      functions.routeSayfa("Yatırımcı Güncelle", this)
    },
    musteriAra() {
      this.postPage = 0;
      this.page = 1
      this.dateVisible = false;
      //siparisNo, adSoyad, telefon, country, city, state, baslangicTarihi, bitisTarihi, durum, baslangic, limit,
      if (this.firmaAdiAra.length > 0 || this.unvanAra.length > 0 || this.adresAra.length > 0 || this.telefonAra.length > 0 || this.epostaAra.length > 0) {
        try {
          this.searchLoading = true;
          //kullaniciAdi, adSoyad, mail, telefon, durum, baslangic, limit)
          musteriService.musteriFilter(this.firmaAdiAra, this.unvanAra, this.adresAra, this.telefonAra, this.epostaAra, this.selectIcon, this.postPage, this.sizes).then(response => {
            if (response.status == 200) {
              this.musteriProjeList = response.data;
              this.total = response.count
            }
            localStorage.setItem("userDataDemirag", response.token);
            this.searchLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else if (error.status == 404) {
                this.musteriProjeList = []
              }
            } else {
              //notification.Status(503, this)
            }
            this.searchLoading = false;
          })
        } catch (e) {
          // notification.Status("danger", this, "An error occurred during the customer search process.")
          this.searchLoading = false
        }
      } else {
        //this.getMusteriListesi();
        this.getMusteriProjeListesi();
        // this.getMusteriSayisi();
      }
    },
    refreshPage(durum = '1') {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;
      this.radio = durum;
      this.selectIcon = durum;

      // this.getMusteriSayisi();
      //this.getMusteriListesi();
      this.getMusteriProjeListesi(durum);
    },
    musteriSifreGuncelle(musteriID) {
      this.$confirm(this.$t("src.views.apps.yatirimci.messages.sendMessage"), this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          notification.Status("warning", this, "The message is being delivered. Please wait.")
          musteriService.musteriSifreGuncelle(musteriID).then(response => {
            localStorage.setItem("userDataDemirag", response.token);
            notification.Status("success", this, "Message Sent Successfully.");
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
          })
        } catch (e) {
          // notification.Status("danger", this, "Failed to send password to client. An error occurred during the operation.")
        }
      })
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    startUpdate() {
      this.musteriForm.firmaAdi = this.editDialogData.firmaAdi;
      this.musteriForm.unvan = this.editDialogData.unvan;
      this.musteriForm.eposta = this.editDialogData.mail;
      this.musteriForm.telefon = this.editDialogData.telefon;
      // this.musteriForm.dogumTarihi = moment(this.editDialogData.dogumTarihi).format("DD-MM-YYYY");
    },
    changeMusteriDurum(selection, durum) {
      this.$confirm("Yatırımcının durumunu güncellemek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          this.stateLoading = true;
          musteriService.customerStatusUpdate(selection.musteriID, durum).then(response => {
            if (response.status == 200) {
              // this.getMusteriListesi();
              this.getMusteriProjeListesi();
            }
            this.stateLoading = false;
            notification.Status("success", this, response.msg);
            localStorage.setItem("userDataDemirag", response.token);
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
            this.stateLoading = false;
          })
        } catch (e) {
          // notification.Status("success", this, "An error occurred while fetching the customer number.");
          this.stateLoading = false;
        }
      })
    },
    getMusteriProjeListesi(durum) {
      const logInYetkiler = this.$store.state.yetkiListesi;
      try {
        if (durum) this.selectIcon = durum
        this.loading = true;
        musteriService.musteriListesi(this.selectIcon, this.postPage, this.sizes).then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          // if(logInYetkiler != 1){
          //     const siraliYetkiler = this.siralaYetkiKodlari(logInYetkiler);
          //     const siraliYoneticiYetkileri = this.siralaYetkiKodlari2(response.yoneticiYetkileri);

          //     const eslesmeVar = this.karsilastirYetkiKodlari(siraliYetkiler, siraliYoneticiYetkileri);

          //     if (!eslesmeVar) {
          //         notification.Status("warning", this, "Yetkilerinizde değişiklik yapılmıştır. Lütfen tekrar giriş yapınız.")
          //         this.$store.commit('setLogout');
          //         this.$router.push("/login");
          //         localStorage.removeItem("userDataDemirag")
          //     }
          // }
          if (response.status == 200) {
            this.musteriList = response.data;
            this.musteriProjeList = response.data;
            this.total = parseInt(response.toplamKayit);

            // if(this.musteriProjeList.length > 0){
            //     this.musteriProjeList.forEach(yatirimci => {

            //     if(yatirimci.projeler.length > 0){
            //         yatirimci.projeler.forEach(yatirim => {
            //             yatirim.toplamProjeSuresi = 0
            //             yatirim.baslamaGecenSure = 0
            //             yatirim.baslamaSureYuzde = 0
            //             yatirim.kalanSure = 0

            //             yatirim.toplamProjeSuresi = getDays(yatirim.baslangicTarihi, yatirim.bitisTarihi);
            //             projeBasladiMi(moment().format("YYYY-MM-DD"),yatirim.baslangicTarihi) ? yatirim.baslamaGecenSure = getDays(yatirim.baslangicTarihi, moment().format("YYYY-MM-DD")) : yatirim.baslamaGecenSure = 0
            //             yatirim.kalanSure = yatirim.toplamProjeSuresi - yatirim.baslamaGecenSure
            //             if(yatirim.kalanSure < 0 ) {
            //                 yatirim.kalanSure = 0
            //             }

            //             yatirim.baslamaSureYuzde = parseFloat(parseInt(yatirim.baslamaGecenSure) * 100 / parseInt(yatirim.toplamProjeSuresi)).toFixed(1)
            //             if(yatirim.baslamaSureYuzde > 100)
            //             {
            //                 yatirim.baslamaSureYuzde = 100
            //             }

            //             yatirim.toplamSozlesme = 0
            //             yatirim.bitenSozlesme = 0
            //             // burada projede bulunan sozlesmeleri oranlarını yuzdelik değerlere ceviriyoruz
            //             // yuzde deger = sozlesmeYuzde * 100 / toplamSozlesmelerYuzdeDegerleriToplamlari
            //             // 2 foreach donmesinin sebebi once projedeki sözleşmelerin yuzdelerinin toplamlarına ihtiyacımız olmasından! 2.foreach yuzdelik orana cevirmek için.
            //             yatirim.sozlesmeler.forEach(sozlesme => {
            //                 yatirim.toplamSozlesme += parseFloat(sozlesme.yuzdeDeger)
            //                 yatirim.bitenSozlesme += sozlesmeBittiMi(moment().format("YYYY-MM-DD"), sozlesme.isTeslimTarihi) ? parseFloat(sozlesme.yuzdeDeger) : 0
            //             })
            //             yatirim.bitmeYuzdesi = parseFloat(yatirim.bitenSozlesme * 100 / yatirim.toplamSozlesme).toFixed(1)


            //             yatirim.sozlesmeler.forEach(s => {
            //                 s.toplamYuzde = parseFloat((s.yuzdeDeger) * 100 / yatirim.toplamSozlesme).toFixed(1)

            //                 // sozlesmenin başlangıc ve bitiş tarihleri arasında hangi aylar var ve o aylarda kac gun is yapılmıs(yapılacak) objesini donduren fonksiyon
            //                 // bu kodlar sozlesmeleri hangi tarihlerde yani hangi aylarda yuzde kac iş yapılması gerektiğini temsil ediyor. O yüzden ay ay kac gun calısıldıgı yuzdeliğe ceviriliyor (o ay calısılan gun * 100 / aylarda calısılan günlerin toplamı)
            //                 s.toplamCalisilanGun = 0
            //                 s.sozlesmeAylari = getMonthsBetween(s.baslamaTarihi, s.isTeslimTarihi)


            //                 //console.log(s.sozlesmeBaslik)
            //                 //console.log(s.sozlesmeAylari)
            //                 s.sozlesmeAylari.forEach(ay => {
            //                     //console.log(yatirim.projeBaslik)
            //                     //console.log(s)
            //                     s.toplamCalisilanGun += parseInt(ay.days)
            //             //console.log("ay.day - > " + ay.days )
            //                 })
            //             //console.log(s.toplamCalisilanGun)
            //                 s.sozlesmeAylari.forEach((ay, index) => {
            //                     //console.log("index -> " + index)
            //                     // eger tek bir ay içinde yapılcaksa sozlesme o zaman sozlesme gunlerini ayda bulunan günlere göre yuzdelik orana cevirdik
            //                     // birden fazla ise aralık yani sözleşmek ocak subat mart aylarında geçerli ise örneğin, o zaman ocak ayı için yuzdelik hesap toplam is gunune gore hesaplandı. ocak ayındaki gun * 100 / toplam iş gunu şeklinde
            //                     var daysInMonth = this.tarihler.find(e => e.monthIndex == ay.monthIndex)
            //                 // console.log(this.tarihler.find(e => e.monthIndex == ay.monthIndex))
            //                 // console.log("Proje Adı " + yatirim.projeBaslik)
            //                     //console.log("Sözleşme Adı " + s.sozlesmeBaslik)
            //                     //console.log("daysInMonth.day " + daysInMonth.days)


            //                     ay.dayPercentage = s.sozlesmeAylari.length == 1 ? parseFloat(parseInt(ay.days) * 100 / daysInMonth.days).toFixed(1) : index > 0 && index < s.sozlesmeAylari.length - 1 ? 100 : parseFloat(parseInt(ay.days) * 100 / daysInMonth.days).toFixed(1)

            //                     //console.log("s.sozlesmeAylari.length " + s.sozlesmeAylari.length)
            //                     //console.log("ay.days "+ay.days)
            //                     //console.log("daysInMonth.days "+daysInMonth.days)
            //                     //console.log("s.toplamCalisilanGun "+s.toplamCalisilanGun)
            //             })
            //                 // ---------------------------------------------------------------------------------------


            //                 // Bugunun tarihi aralık olarak secilen gün ile karsılaştırılıyor ve bulunulan gün başlama tarihinden önce ise bitti = 0, tarihlerin arasında ise bitti = 1, bitiş tarihini geçmiş ise bitti = 2 (bitti değişkeni o sözleşmenin durumunu temsil ediyor.)
            //                 s.bitti = checkDateRange(s.baslamaTarihi, s.isTeslimTarihi) // durum = 0 başlamadı, durum = 1 başlandı, durum = 2 bitti
            //                 //console.log("başlama" + s.baslamaTarihi)
            //             //   console.log("bitme" + s.isTeslimTarihi)
            //                 })
            //             })
            //         }
            //     })
            // }


          }
          this.loading = false;

        }).catch(err => {
          console.log(err);
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.musteriProjeList = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    routeMusteri(name, scope) {
      if (scope) {
        this.$store.commit('changeMusteriUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * this.sizes) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      //this.getMusteriListesi();
      this.getMusteriProjeListesi();
    },
    handleChange(event) {
      this.selectIcon = event;
      this.page = 1;
      this.postPage = 0;
      //this.getMusteriListesi();
      this.getMusteriProjeListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.firmaAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      //this.getMusteriListesi();
      this.getMusteriProjeListesi();
    },
  }
}

function getDays(tarih1, tarih2) {
  // Tarihleri Moment objelerine dönüştür ve gün farkını hesapla
  const tarih1Moment = moment(tarih1);
  const tarih2Moment = moment(tarih2);
  const gunFarki = tarih2Moment.diff(tarih1Moment, 'days');

  // Sonucu döndür
  return gunFarki;
}

function sozlesmeBittiMi(tarih1, tarih2) {
  // Tarihleri Moment objelerine dönüştür
  const momentTarih1 = moment(tarih1);
  const momentTarih2 = moment(tarih2);

  // Tarih1 tarih2'den sonra mı?
  return momentTarih1.isAfter(momentTarih2);
}

function projeBasladiMi(bugun, baslangicTarihi) {
  const momentBugun = moment(bugun)
  const momentBaslangic = moment(baslangicTarihi)

  return momentBugun.isAfter(momentBaslangic)
}

function getMonthsBetween(start, end) {

  moment.locale('tr');
  const results = [];

  for (let m = moment(start); m.isSameOrBefore(end, 'month'); m.add(1, 'months')) { //for (let m = moment(start); m.isBefore(end); m.add(1, 'months')) {
    const monthStart = moment(m).startOf('month');
    const monthEnd = moment(m).endOf('month');

    let daysInMonth = monthEnd.diff(monthStart, 'days') + 1 //ayın günlerinikaç gün olduğunu hesaplıyor

    if (m.isSame(moment(start).startOf('month'), 'month')) {
      daysInMonth -= moment(start).date();
    }
    if (m.isSame(moment(end).endOf('month'), 'month')) {
      daysInMonth -= monthEnd.date() - moment(end).date();
    }

    results.push({
      month: monthStart.format('MMMM'),
      monthIndex: parseInt(monthStart.month()) + 1,
      days: daysInMonth   //- 1
    });
  }
  return results;
}

function checkDateRange(start, end) {
  const today = moment();
  if (today.isBefore(start, 'day')) {
    return 0;
  } else if (today.isBetween(start, end, 'day')) {
    return 1;
  } else {
    return 2;
  }
}
</script>

<style lang="scss">
.pdf-button {
  color: #378CE7;
  margin-right: 16px;

  span {
    font-size: 23px;
  }
}

.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.pdf-modal {
  margin-top: 50px;

  ul {
    padding-left: 10px;
    padding-right: 10px;
    list-style-type: none;

    li {
      transition: 200ms;
      display: flex;
      place-content: space-between;
      place-items: center;
      background-color: #EEEEEE;
      border-radius: 6px;
      margin: 6px;
      padding: 9px;

      &:hover {
        transition: 200ms;
        background-color: #DDDDDD;
      }
    }

    p {
      margin: 0;
      display: inline-block;
      font-weight: bolder;
    }

    span {
    }
  }
}

.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
/*
    .tablo{
        background-color: rgb(59, 123, 179); /*rgb(148, 197, 240); 
    }*/

.tablo th.el-table__cell > .cell {
  background-color: aliceblue;
}


.islem-button {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.buttonDel {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.el-table .cell {
  line-height: 17px !important;
}

.el-table thead {
  line-height: 30px !important;
}
</style>